import type { PageHelp } from '../network-help.data';

export const L10N_fa_g1: Record<string, PageHelp> = {
  customers: {
    title: 'مشتریان',
    tag: 'دفترچه CRM',
    tagline: 'رکورد اصلی مسافران و شرکت‌هایی که یک آژانس به آن‌ها می‌فروشد.',
    business: {
      lead: 'مشتریان همان کسانی هستند که آژانس واقعاً به آن‌ها می‌فروشد — مسافران تفریحی، حساب‌های سازمانی و همراهانی که با آن‌ها سفر می‌کنند. نگه‌داشتن یک رکورد تمیز به‌ازای هر مشتری همان چیزی است که به پلتفرم اجازه می‌دهد رزروها را از پیش پر کند، یک بخش را متفاوت قیمت‌گذاری کند، یک باشگاه وفاداری اجرا کند و صورت‌حساب را برای طرف درست صادر کند. مشتری‌ای که قابل صورت‌حساب کردن باشد در پایین‌دست به یک طرف حساب (طرف حساب) در حسابداری هم تبدیل می‌شود.',
      points: [
        { title: 'یک منبع حقیقت', desc: 'نام، مدرک، اطلاعات تماس و رضایت روی رکورد مشتری قرار دارند — صفحه‌های رزرو از آن می‌خوانند، بنابراین یک مسافر یک‌بار وارد می‌شود و همه‌جا دوباره استفاده می‌شود.' },
        { title: 'بخش‌ها قیمت را هدایت می‌کنند', desc: 'یک مشتری می‌تواند به یک گروه مشتری تعلق داشته باشد؛ سپس لایه Retail در Markup & Rules می‌تواند آن گروه را متفاوت قیمت‌گذاری کند — تخفیف برای VIPها، کارمزد برای مراجعان حضوری.' },
        { title: 'رضایت ثبت می‌شود', desc: 'رضایت بازاریابی و رضایت پردازش داده به‌ازای هر مشتری ذخیره می‌شود تا ارتباط‌گیری مطابق مقررات بماند.' },
      ],
    },
    software: {
      lead: 'فهرستی قابل جست‌وجو از هر مشتری، همراه با ستون‌های تماس، وفاداری و رضایت که برای مدیریت آن‌ها نیاز دارید.',
      points: [
        { title: 'یافتن و فیلتر', desc: 'با نام، تلفن، ایمیل یا کد ملی جست‌وجو کنید؛ یک ردیف را برای پروفایل کامل باز کنید.' },
        { title: 'ویرایش پروفایل', desc: 'کشوی ویرایش هویت، تلفن/واتساپ (کد شماره‌گیری و شماره جدا)، ملیت، کانال و زبان ترجیحی، سطح VIP و یادداشت‌های داخلی را ثبت می‌کند؛ همراهانی که با آن‌ها سفر می‌کنند را اضافه کنید.' },
        { title: 'وفاداری در یک نگاه', desc: 'هر پروفایل موجودی امتیاز، سطح و تاریخچه مشتری را همراه با کسب / استفاده / تعدیل دستی نشان می‌دهد.' },
      ],
    },
    related: ['customer-groups', 'loyalty', 'markup', 'agencies'],
  },

  'customer-groups': {
    title: 'گروه‌های مشتری',
    tag: 'بخش‌بندی',
    tagline: 'مشتریان را در بخش‌ها برچسب بزنید تا لایه قیمت‌گذاری Retail بتواند با آن‌ها متفاوت رفتار کند.',
    business: {
      lead: 'یک گروه مشتری یک بخش نام‌گذاری‌شده است — «VIPها»، «سازمانی — Acme»، «مراجعان حضوری» — که می‌توانید بر مبنای آن قیمت‌گذاری کنید. این نظیر سمت‌مشتریِ یک گروه آژانس است: جایی که گروه‌های آژانس قواعد Wholesale/Distribution را محدوده‌بندی می‌کنند، گروه‌های مشتری لایه Retail را محدوده‌بندی می‌کنند، بنابراین آژانس فروشنده می‌تواند به بخشی از مشتریان خودش پاداش دهد یا اضافه‌بها ببندد.',
      points: [
        { title: 'اهرمی برای حاشیه خرده‌فروشی', desc: 'عضویت در گروه همان چیزی است که یک قاعده Retail آن را هدف می‌گیرد — مثلاً تخفیف وفاداری −۳٪ برای گروه VIP، یا کارمزد خدمات برای مراجعان حضوری تأییدنشده.' },
        { title: 'عضویت، نه سلسله‌مراتب', desc: 'یک مشتری صرفاً به یک گروه تعلق دارد؛ هیچ تودرتویی وجود ندارد. یک برچسب روشن قیمت‌گذاری را قابل‌پیش‌بینی نگه می‌دارد.' },
        { title: 'در مالکیت آژانس', desc: 'هر آژانس گروه‌های خودش را روی مشتریان خودش تعریف می‌کند — این‌ها در سراسر شبکه نشت نمی‌کنند.' },
      ],
    },
    software: {
      lead: 'گروه‌ها را بسازید و مشتریان را تخصیص دهید، سپس از محدوده Group یک قاعده قیمت‌گذاری Retail به گروه ارجاع دهید.',
      points: [
        { title: 'ساخت و نام‌گذاری یک گروه', desc: 'یک گروه را با کد و نام تعریف کنید؛ همراه با تحول بخش‌ها آن را فعال یا بایگانی کنید.' },
        { title: 'تخصیص اعضا', desc: 'مشتریان را به یک گروه اضافه یا از آن حذف کنید؛ تعداد روی گروه و روی ردیف‌های محدوده‌شده به Group در Markup & Rules نمایان می‌شود.' },
        { title: 'اتصال به قیمت‌گذاری', desc: 'در Markup & Rules، محدوده‌شریک = Group را روی یک قاعده Retail انتخاب کنید و این گروه را برگزینید — هر رزرو منطبق برای اعضای آن قاعده را می‌گیرد.' },
      ],
    },
    examples: [
      {
        title: 'یک تخفیف گروه VIP روی لایه Retail',
        rows: [
          { label: 'جمع جزء مسافر (پیش از قاعده خرده‌فروشی)', value: '11,024,000' },
          { label: 'Retail DISCOUNT −۳٪ · گروه = VIPها', value: '−330,720', accent: 'success', strong: true },
          { label: 'مشتری VIP می‌پردازد', value: '10,693,280' },
        ],
        note: 'همان رزرو برای مشتری غیر VIP قاعده را رد می‌کند و ۱۱٬۰۲۴٬۰۰۰ می‌پردازد. عضویت در گروه تنها چیزی است که متفاوت است.',
      },
      {
        title: 'یک کارمزد خدمات مراجع حضوری — جهت مخالف',
        rows: [
          { label: 'جمع جزء مسافر', value: '11,024,000' },
          { label: 'Retail SERVICE_FEE +150,000 · گروه = مراجعان حضوری', value: '+150,000', accent: 'accent', strong: true },
          { label: 'مشتری مراجع حضوری می‌پردازد', value: '11,174,000' },
        ],
        note: 'یک SERVICE_FEE ثابت به یک بخش تأییدنشده اضافه‌بها می‌بندد. قواعد ثابت اندازه کرایه را نادیده می‌گیرند — هر رزرو مراجع حضوری همان ۱۵۰٬۰۰۰ را می‌افزاید، هر قیمتی که بلیت داشته باشد.',
      },
      {
        title: 'نرخ خالص سازمانی — یک گروه می‌تواند یک قرارداد مذاکره‌شده را نیز باز کند',
        rows: [
          { label: 'جمع جزء مسافر استاندارد', value: '11,024,000' },
          { label: 'Retail DISCOUNT −۶٪ · گروه = سازمانی · Acme', value: '−661,440', accent: 'success', strong: true },
          { label: 'کارمند Acme می‌پردازد', value: '10,362,560' },
        ],
        note: 'یک تخفیف گروهی عمیق‌تر یک قرارداد سازمانی را کدگذاری می‌کند: هر کسی که در «سازمانی · Acme» برچسب خورده باشد به‌طور خودکار ۶٪ تخفیف مذاکره‌شده Acme را می‌گیرد — بدون بازنویسی‌های به‌ازای هر رزرو.',
      },
    ],
    related: ['customers', 'markup', 'agency-groups', 'loyalty'],
  },

  loyalty: {
    title: 'باشگاه وفاداری',
    tag: 'Voyager Rewards',
    tagline: 'برنامه امتیاز آژانس — چگونه مسافران امتیاز کسب می‌کنند، سطح بالا می‌روند و امتیاز خرج می‌کنند.',
    business: {
      lead: 'یک باشگاه وفاداری مسافران یک‌بارمصرف را به مسافران تکراری تبدیل می‌کند. مشتریان همان‌طور که رزرو می‌کنند امتیاز کسب می‌کنند، سطوحی را بالا می‌روند که مزایا و نرخ‌های کسب بهتری را باز می‌کنند، و امتیازها را در برابر رزروهای آینده خرج می‌کنند. موجودی معوقه یک بدهی واقعی است که آژانس حمل می‌کند، بنابراین باشگاه با نرخ‌های صریح کسب و استفاده اجرا می‌شود.',
      points: [
        { title: 'حفظ مشتری، کمّی‌شده', desc: 'امتیازها و سطوح به مشتری دلیلی می‌دهند که به‌جای یک رقیب دوباره با شما رزرو کند.' },
        { title: 'سطوح بر اساس مجموع کسب‌شده در طول عمر', desc: 'سطح یک مشتری بازتاب امتیازهای کسب‌شده در طول عمر است، بنابراین خرج‌کردن هرگز او را تنزل نمی‌دهد — Bronze ← Silver ← Gold ← Platinum، هرکدام با ضریب کسب بالاتر.' },
        { title: 'امتیازها یک بدهی هستند', desc: 'هر امتیاز خرج‌نشده پولی است که بدهکار هستید؛ نمای کلی باشگاه کل امتیازها و بدهی ارزی را نمایان می‌کند تا در دفاتر بماند.' },
      ],
    },
    software: {
      lead: 'یک نمای کلی باشگاه به‌علاوه دو چیزی که آن را اجرا می‌کنند: تنظیمات (نرخ‌ها + محرک) و قواعد کسب خودکار.',
      points: [
        { title: 'شاخص‌های کلیدی نمای کلی', desc: 'اعضا، کل امتیازها، بدهی و توزیع به‌ازای هر سطح — به‌صورت زنده از دفتر کل محاسبه می‌شود.' },
        { title: 'تنظیمات باشگاه', desc: 'نرخ کسب، نرخ استفاده (امتیاز به‌ازای هر واحد)، انقضای امتیاز و محرک کسب خودکار را تنظیم کنید — اعطا در ISSUE (تحقق‌یافته) یا در PAID (پرداخت دریافت‌شده).' },
        { title: 'قواعد کسب', desc: 'قواعد امتیاز به‌ازای هر محصول را تألیف کنید (مثلاً پروازها ۲ برابر به‌ازای هر واحد کسب می‌کنند)؛ تکمیل یک رزرو به‌طور خودکار امتیازها را از قاعده منطبق اعطا می‌کند. کسب / استفاده / تعدیل به‌ازای هر مشتری روی هر پروفایل است.' },
      ],
    },
    modes: {
      lead: 'دو مفهوم مجزای سطح وجود دارد — آن‌ها را با هم اشتباه نگیرید.',
      modes: [
        { name: 'سطح Loyalty', when: 'کسب‌شده', desc: 'Bronze / Silver / Gold / Platinum، مشتق‌شده از امتیازهای کسب‌شده در طول عمر. ضریب کسب و مزایا را هدایت می‌کند. هرگز دستی تنظیم نمی‌شود.' },
        { name: 'سطح VIP', when: 'دستی', desc: 'یک پرچم جداگانه که یک کارشناس روی رکورد مشتری تنظیم می‌کند (Standard / Silver / Gold / VIP) برای مدیریت خدمات — مستقل از امتیازهای وفاداری.' },
      ],
    },
    examples: [
      {
        title: 'آستانه‌های سطح — بر اساس امتیازهای کسب‌شده در طول عمر تنظیم می‌شود',
        rows: [
          { label: 'Bronze · +۰ کسب‌شده', value: '1× earn' },
          { label: 'Silver · +۲٬۰۰۰ کسب‌شده', value: '1.25× earn' },
          { label: 'Gold · +۶٬۰۰۰ کسب‌شده', value: '1.5× earn', accent: 'info' },
          { label: 'Platinum · +۱۵٬۰۰۰ کسب‌شده', value: '2× earn', accent: 'success' },
        ],
        note: 'سطح مجموع کسب‌شده در طول عمر را می‌خواند، بنابراین خرج‌کردن امتیاز هرگز یک مشتری را تنزل نمی‌دهد.',
      },
      {
        title: 'کسب خودکار روی یک رزرو، و یک جهش سطح',
        rows: [
          { label: 'کسب‌شده در طول عمر پیش‌از (Silver)', value: '5,600' },
          { label: 'قاعده پروازها · ۲ امتیاز به‌ازای هر واحد × ۲۵۰', value: '+500', accent: 'info', strong: true },
          { label: 'کسب‌شده در طول عمر پس‌از ← Gold', value: '6,100' },
        ],
        note: 'امتیازها به‌طور خودکار وقتی ثبت می‌شوند که رزرو به محرک کسب باشگاه (ISSUE یا PAID) برسد. عبور از ۶٬۰۰۰ مشتری را به Gold ارتقا می‌دهد — از آن پس کسب ۱٫۵ برابر.',
      },
      {
        title: 'استفاده از امتیازها (پیش‌فرض ۱۰۰ امتیاز = ۱ واحد تخفیف)',
        rows: [
          { label: 'موجودی امتیاز', value: '8,000' },
          { label: 'استفاده از ۵٬۰۰۰ امتیاز ← تخفیف', value: '−50', accent: 'success' },
          { label: 'موجودی باقی‌مانده', value: '3,000', strong: true },
        ],
        note: 'نرخ استفاده در تنظیمات باشگاه تنظیم می‌شود؛ موجودی امتیازهای قابل‌خرج است، متمایز از مجموع کسب‌شده در طول عمر که سطح را تعیین می‌کند.',
      },
      {
        title: 'بدهی باشگاه — امتیازهای معوقه چقدر می‌ارزند',
        rows: [
          { label: 'کل امتیازهای خرج‌نشده در میان اعضا', value: '2,400,000' },
          { label: '÷ نرخ استفاده (۱۰۰ امتیاز = ۱)', value: '÷ 100' },
          { label: 'بدهی ارزی در دفاتر', value: '24,000', accent: 'accent', strong: true },
        ],
        note: 'نمای کلی این را نمایان می‌کند تا باشگاه هرگز یک هزینه پنهان نباشد. بالابردن نرخ استفاده (امتیاز بیشتر به‌ازای هر واحد) بدهی را کاهش می‌دهد اما امتیازها را برای مشتری کم‌ارزش‌تر می‌کند — اهرمی برای توازن.',
      },
    ],
    related: ['customers', 'customer-groups', 'markup'],
  },

  agencies: {
    title: 'آژانس‌ها',
    tag: 'دفترچه',
    tagline: 'دفترچه اصلی کسب‌وکارهای سفر B2B که روی پلتفرم داد و ستد می‌کنند.',
    business: {
      lead: 'آژانس‌ها مشتریان B2B پلتفرم هستند — شرکت‌های سفری که موجودی را به آن‌ها می‌فروشید. هرکدام شرایط تجاری و انطباقی را حمل می‌کند که نحوه داد و ستد آن را حاکم می‌کند: سطح آن، کیف پول یا خط اعتباری آن، و وضعیت KYC آن.',
      points: [
        { title: 'سطوح شرایط را تعیین می‌کنند', desc: 'سطح یک آژانس اهرم پشت قیمت‌گذاری آن است — قواعد محدوده‌شده به Tier در موتور Markup & Rules را تغذیه می‌کند، بنابراین حجم می‌تواند با حاشیه بهتر پاداش گیرد.' },
        { title: 'کیف پول و اعتبار حد داد و ستد هستند', desc: 'یک آژانس در برابر یک کیف پول پیش‌پرداخت‌شده یا یک خط اعتباری تأییدشده رزرو می‌کند؛ آن موجودی همان چیزی است که ریسک پلتفرم را سقف‌گذاری می‌کند.' },
        { title: 'KYC داد و ستد را دروازه‌بانی می‌کند', desc: 'یک آژانس جدید تنها زمانی زنده می‌شود که KYC تأیید شود — ستون وضعیت به‌ازای هر ردیف نشان می‌دهد چه کسی داد و ستد می‌کند و چه کسی مسدود است.' },
      ],
    },
    software: {
      lead: 'فهرستی قابل جست‌وجو از هر آژانس، همراه با ستون‌های تجاری و انطباقی که برای مدیریت آن‌ها در یک نگاه نیاز دارید.',
      points: [
        { title: 'مرور و فیلتر', desc: 'با نام، تماس یا کد جست‌وجو کنید و بر اساس سطح یا وضعیت فیلتر کنید تا بیابید چه کسی مهم است.' },
        { title: 'خواندن ستون‌های سلامت', desc: 'موجودی کیف پول، بهره‌برداری اعتبار و وضعیت KYC به‌ازای هر ردیف نمایان می‌شود.' },
        { title: 'باز کردن یک رکورد', desc: 'روی یک ردیف کلیک کنید تا پروفایل آژانس باز شود — شرایط، SIGNها، کانال‌های فروش، نقش‌ها و دسترسی آن را ویرایش کنید.' },
      ],
    },
    related: ['agency-profile', 'agents', 'agency-onboarding', 'markup'],
  },

  markup: {
    title: 'Markup و قواعد',
    tag: 'موتور قیمت‌گذاری',
    tagline: 'جایی که هر لایه از حاشیه — از مالک SIGN تا فروشنده مجدد تا مسافر — تعریف می‌شود.',
    business: {
      lead: 'این نحوه ساخته‌شدن یک قیمت از کرایه خالص یک تأمین‌کننده تا آنچه مسافر می‌پردازد است. موتور لایه‌ای است: یک markup لایه Wholesale (مالک SIGN از یک فروشنده مجدد دریافت می‌کند)، یک کارمزد لایه Distribution (مالک کانال از آژانسی که از طریق کانالش می‌فروشد دریافت می‌کند)، و یک حاشیه لایه Retail (markup خودِ آژانس فروشنده به مشتری). هر لایه پول یک طرف متفاوت است.',
      points: [
        { title: 'سه لایه، سه رابطه', desc: 'Wholesale = مالک SIGN ← فروشنده مجدد؛ Distribution = مالک کانال ← فروشنده؛ Retail = فروشنده ← مسافر. یک قاعده همیشه دقیقاً به یک لایه تعلق دارد.' },
        { title: 'هدف‌گیری‌شده بر اساس بخش', desc: 'قواعد بر اساس محصول، تأمین‌کننده، ایرلاین، مسیر، کابین، SIGN یا کانال، سطح یا گروه شریک، یا یک آژانس شریک مشخص محدود می‌شوند — تا بتوانید دقیق قیمت‌گذاری کنید.' },
        { title: 'حفاظ‌ها از قیمت محافظت می‌کنند', desc: 'سقف‌های حداقل / حداکثر، اولویت و وضعیت فعال / غیرفعال جلوی یک قاعده بد را می‌گیرند که یک کرایه را غیررقابتی یا غیرسودآور کند.' },
      ],
    },
    software: {
      lead: 'یک موتور قواعد که با ویژگی‌بودن حل می‌شود — مشخص‌ترین قاعده منطبق درون هر لایه برنده می‌شود.',
      points: [
        { title: 'ترتیب ویژگی‌بودن', desc: 'شریک ← سطح ← SIGN / کانال ← مسیر ← پیش‌فرض مالک. حل‌کننده این نردبان را برای هر لایه از یک رزرو طی می‌کند.' },
        { title: 'امتیازدهی نحوه انتخاب حل‌کننده است', desc: 'هر بعد تطبیق غیر-وایلدکارتی که یک قاعده تنظیم می‌کند وزن ثابتی به امتیاز آن می‌افزاید. برنده هر لایه = بالاترین امتیاز. تساوی ← `priority` بالاتر برنده می‌شود؛ باز هم تساوی ← قاعده‌ای که اخیراً به‌روزرسانی شده برنده می‌شود. شبیه‌ساز امتیاز را روی هر کارت نامزد نشان می‌دهد تا دقیقاً ببینید چرا یک قاعده بر دیگری غلبه کرد.' },
        { title: 'ساخت و فیلتر قواعد', desc: 'لایه یک قاعده، نوع تعدیل، مقدار (درصد / ثابت / پلکانی)، مبنا و محدوده را تألیف کنید؛ فهرست رو به رشد را بر اساس نوع، محصول، محدوده شریک یا وضعیت فیلتر کنید.' },
        { title: 'شبیه‌سازی پیش از زنده‌شدن', desc: 'شبیه‌ساز داخلی یک رزرو فرضی را قیمت‌گذاری می‌کند و دقیقاً نشان می‌دهد کدام قاعده در هر لایه شلیک می‌کند — بدون هیچ ریسکی برای قیمت‌گذاری زنده.' },
      ],
    },
    examples: [
      {
        title: 'وزن‌های ویژگی‌بودن — هر بعد تطبیق چقدر می‌ارزد',
        rows: [
          { label: 'شریک = یک AGENCY مشخص', value: '100' },
          { label: 'SIGN (wholesale) · کانال (distribution)', value: '90' },
          { label: 'مبدأ و مقصد — فرودگاه / ایستگاه', value: '70' },
          { label: 'GROUP شریک', value: '60' },
          { label: 'مبدأ و مقصد — شهر', value: '50' },
          { label: 'TIER شریک', value: '40' },
          { label: 'منطقه', value: '35' },
          { label: 'تأمین‌کننده · ایرلاین · نوع کرایه', value: '30 each' },
          { label: 'کابین', value: '25' },
          { label: 'محصول', value: '20' },
        ],
        note: 'امتیاز یک قاعده مجموع وزن‌های هر بعد غیر-وایلدکارتی است که واقعاً با رزرو تطبیق یافته است. وایلدکاردها (خالی) امتیاز نمی‌گیرند — فقط مستثنا نمی‌کنند.',
      },
      {
        title: 'دو قاعده رقابت می‌کنند — بالاترین امتیاز برنده می‌شود',
        rows: [
          { label: 'رزرو: فروشنده = Nomad (سطح GOLD)، محصول = پرواز', value: '' },
          { label: 'قاعده A · WHOLESALE · TIER=GOLD + محصول=پرواز', value: '40 + 20 = 60', accent: 'info' },
          { label: 'قاعده B · WHOLESALE · AGENCY=Nomad', value: '100', accent: 'success' },
          { label: 'برنده', value: 'Rule B', strong: true },
        ],
        note: 'هر دو قاعده با این رزرو تطبیق می‌یابند. قفل آژانس-شریک قاعده B به‌تنهایی ۱۰۰ امتیاز می‌گیرد — بر ترکیب سطح+محصول قاعده A (۶۰) غلبه می‌کند. شریک-مشخص، مشخص‌ترین بعدی است که موتور می‌شناسد.',
      },
      {
        title: 'امتیاز یکسان — اولویت تساوی را می‌شکند',
        rows: [
          { label: 'رزرو: محصول=پرواز، کابین=BUSINESS، تأمین‌کننده=Amadeus', value: '' },
          { label: 'قاعده X · محصول+کابین (۲۰+۲۵) · priority=۰', value: 'score 45 · pri 0' },
          { label: 'قاعده Y · محصول+تأمین‌کننده (۲۰+۳۰) · priority=۱۰', value: 'score 50 · pri 10', accent: 'success' },
          { label: 'برنده', value: 'Rule Y (higher score)', strong: true },
        ],
        note: 'Y روی امتیاز خام برنده می‌شود (۵۰ > ۴۵). اگر دو قاعده روی امتیاز مساوی شوند، `priority` آن را می‌شکند — و اگر `priority` هم مساوی شود، قاعده‌ای که اخیراً به‌روزرسانی شده برنده می‌شود. آن تساوی‌شکن آخر یعنی ویرایش یک قاعده موجود عملاً آن را به بالای یک گروهِ در غیر این صورت مساوی تازه می‌کند.',
      },
      {
        title: 'Wholesale — مالک SIGN ← فروشنده مجدد (روی کرایه خالص)',
        rows: [
          { label: 'خالص ایرلاین', value: '10,000,000' },
          { label: 'MARKUP +۴٪ از خالص', value: '+400,000', accent: 'info' },
          { label: 'هزینه فروشنده مجدد', value: '10,400,000', strong: true },
        ],
      },
      {
        title: 'Retail — فروشنده ← مسافر (روی ناخالص جاری)',
        rows: [
          { label: 'مجموع جاری', value: '10,400,000' },
          { label: 'MARKUP +۶٪ از ناخالص', value: '+624,000', accent: 'success' },
          { label: 'جمع جزء مسافر', value: '11,024,000', strong: true },
        ],
      },
      {
        title: 'Distribution — کارمزد کانال (افزودنی در برابر سهم-درآمد)',
        rows: [
          { label: 'افزودنی +۲٪ روی ۱۱٬۰۲۴٬۰۰۰', value: '+220,480', accent: 'accent' },
          { label: 'سهم-درآمد ۲٪ (از حاشیه)', value: 'قیمت بدون تغییر' },
        ],
        note: 'افزودنی روی کرایه اضافه می‌شود؛ سهم-درآمد قیمت مسافر را دست‌نخورده می‌گذارد و سهم کانال را از حاشیه فروشنده کسر می‌کند.',
      },
      {
        title: 'حالت‌های مقدار — مبنای ۱۰٬۰۰۰٬۰۰۰، رزرو ۳ مسافر / ۲ سگمنت',
        rows: [
          { label: 'درصد · ۵٪ × ۱۰٬۰۰۰٬۰۰۰', value: '500,000' },
          { label: 'ثابت · ۱۵۰٬۰۰۰ به‌ازای هر رزرو', value: '150,000' },
          { label: 'ثابت · ۱۵۰٬۰۰۰ به‌ازای هر مسافر × ۳', value: '450,000' },
          { label: 'ثابت · ۱۵۰٬۰۰۰ به‌ازای هر سگمنت × ۲', value: '300,000' },
          { label: 'درصد + ثابت · ۳٪ + ۲۰۰٬۰۰۰', value: '500,000' },
        ],
        note: 'هر لایه می‌تواند از هر حالتی استفاده کند. نوع تعدیل علامت را تعیین می‌کند: MARKUP / SERVICE_FEE می‌افزایند؛ DISCOUNT / REBATE کم می‌کنند.',
      },
      {
        title: 'آبشار سرتاسری — شریک زیر یک SIGN صادر می‌کند، سپس مجدداً می‌فروشد',
        rows: [
          { label: 'خالص تأمین‌کننده (ایرلاین)', value: '10,000,000' },
          { label: '+ Wholesale MARKUP ۴٪', value: '+400,000', accent: 'info' },
          { label: '+ Retail MARKUP ۶٪', value: '+624,000', accent: 'success' },
          { label: '+ Distribution افزودنی ۲٪', value: '+220,480', accent: 'accent' },
          { label: 'قیمت مسافر', value: '11,244,480', strong: true },
        ],
        note: 'دقیقاً همان چیزی که شبیه‌ساز محاسبه می‌کند. با سهم-درآمد به‌جای افزودنی، مسافر همچنان ۱۱٬۰۲۴٬۰۰۰ می‌پردازد و ۲۲۰٬۴۸۰ کانال از حاشیه فروشنده کسر می‌شود.',
      },
    ],
    related: ['agency-groups', 'sign-access', 'channel-access', 'agencies'],
  },

  'partner-access': {
    title: 'دسترسی شریک',
    tag: 'جفت‌سازی',
    tagline: 'چگونه آژانس‌ها جفت می‌شوند تا اعتبارنامه‌های صدور (SIGNها) و کانال‌های فروش را به اشتراک بگذارند.',
    business: {
      lead: 'هر آژانس اعتبارنامه‌های ایرلاین (SIGNها) یا کانال‌های فروشی را که برای بلیت‌کردن هر چیزی که می‌تواند بفروشد نیاز دارد در اختیار ندارد. دسترسی شریک به دو آژانس اجازه می‌دهد متصل شوند و آن دارایی‌ها را به اشتراک بگذارند — تا یکی بتواند روی SIGN دیگری صادر کند یا از طریق کانال آن بفروشد — و آنچه هر دو می‌توانند بفروشند را گسترش می‌دهد بدون اینکه هیچ‌کدام موجودی جدید بخرد.',
      points: [
        { title: 'قرض‌گرفتن دسترسی، حفظ کنترل', desc: 'مالک دسترسی را اعطا می‌کند و می‌تواند هر زمان آن را باطل کند — اشتراک‌گذاری یک مجوز است، نه انتقال دارایی.' },
        { title: 'هر دو طرف باید موافقت کنند', desc: 'جفت‌سازی و هر اعطا رضایت دوطرفه است: یک پیشنهاد یا درخواست که طرف دیگر پیش از اشتراک هر دارایی می‌پذیرد.' },
        { title: 'دو جهت ارزش', desc: 'آنچه به شرکا به بیرون به اشتراک می‌گذارید و آنچه از آن‌ها استفاده می‌کنید را به‌عنوان دو دفتر کل جداگانه پیگیری می‌کنید.' },
      ],
    },
    software: {
      lead: 'این صفحه جفت‌سازی‌ها و اعطاهای SIGN / کانال فروش را که در میان آن‌ها جریان می‌یابد مدیریت می‌کند.',
      points: [
        { title: 'اتصال با کد آژانس', desc: 'یک درخواست همکاری را با استفاده از کد یکتای آژانسِ یک شریک ارسال کنید؛ آن‌ها آن را می‌پذیرند یا رد می‌کنند.' },
        { title: 'اعطای SIGNها و کانال‌های فروش', desc: 'یک SIGN (اعتبارنامه صدور ایرلاین) یا یک کانال فروش را به یک شریک پیشنهاد دهید، محدوده‌شده و زمان‌محدود؛ گیرنده اعطا آن را می‌پذیرد تا فعال شود.' },
        { title: 'مدیریت هر دو دفتر کل', desc: 'دسترسی‌ای که اعطا کرده‌اید و دسترسی‌ای که دریافت کرده‌اید را مرور کنید، و وقتی یک رابطه پایان می‌یابد آن را باطل کنید.' },
      ],
    },
    examples: [
      {
        title: 'یک SIGN را به اشتراک می‌گذارید — markup لایه wholesale را روی هر بلیت شریک کسب می‌کنید',
        rows: [
          { label: 'شریک یک بلیت EK صادر می‌کند · خالص ایرلاین', value: '10,000,000' },
          { label: 'markup Wholesale شما ۴٪ (به شما می‌پردازند)', value: '+400,000', accent: 'info', strong: true },
          { label: 'هزینه شریک برای بلیت', value: '10,400,000' },
        ],
        note: 'شما هرگز رزرو را لمس نمی‌کنید — به‌اشتراک‌گذاشتن SIGN شما به‌ازای هر بلیتی که شریک زیر آن صادر می‌کند ۴۰۰٬۰۰۰ برای شما کسب می‌کند. آن‌ها هر حاشیه خرده‌فروشی که برای مشتری خودشان می‌افزایند را نگه می‌دارند.',
      },
      {
        title: 'از SIGN یک شریک استفاده می‌کنید — wholesale آن‌ها را می‌پردازید، retail خود را نگه می‌دارید',
        rows: [
          { label: 'یک بلیت EK روی SIGN آن‌ها صادر می‌کنید · خالص', value: '10,000,000' },
          { label: '+ markup Wholesale آن‌ها ۴٪ ← هزینه شما', value: '10,400,000' },
          { label: '+ markup Retail شما ۶٪ به مشتری‌تان', value: '+624,000', accent: 'success' },
          { label: 'مشتری شما می‌پردازد', value: '11,024,000', strong: true },
        ],
        note: 'قرض‌گرفتن یک SIGN به شما اجازه می‌دهد ایرلاینی را که در اختیار ندارید بفروشید. markup wholesale مالک را می‌پردازید و حاشیه retail ۶۲۴٬۰۰۰ خودتان را نگه می‌دارید.',
      },
      {
        title: 'یک کانال فروش را به اشتراک می‌گذارید — سهم-درآمد در برابر افزودنی',
        rows: [
          { label: 'شریک یک کرایه ۱۰٬۰۰۰٬۰۰۰ را از طریق کانال شما می‌فروشد', value: '10,000,000' },
          { label: 'سهم-درآمد ۲٪ (سهم شما، از حاشیه آن‌ها)', value: '+200,000', accent: 'accent', strong: true },
          { label: 'افزودنی ۲٪ (روی کرایه اضافه ← مسافر می‌پردازد)', value: '10,200,000' },
        ],
        note: 'سهم-درآمد ۲۰۰٬۰۰۰ از حاشیه فروشنده برای شما کسب می‌کند با قیمت مسافرِ بدون تغییر؛ افزودنی کارمزد شما را روی کرایه اضافه می‌کند. شما به‌ازای هر اعطا تعیین می‌کنید کدام‌یک.',
      },
    ],
    related: ['sign-access', 'channel-access', 'signs', 'sale-channels'],
  },

  agents: {
    title: 'زیرآژانس‌ها',
    tag: 'زیرمجموعه',
    tagline: 'فروشندگان مجددی که زیر یک آژانس اصلی قرار می‌گیرند و به نمایندگی از آن می‌فروشند.',
    business: {
      lead: 'زیرآژانس‌ها توزیع را گسترش می‌دهند بدون اینکه پلتفرم همه را مستقیماً پذیرش کند. یک آژانس اصلی آن‌ها را جذب می‌کند، شرایط تجاری‌شان را تنظیم می‌کند و پشت داد و ستد آن‌ها می‌ایستد — و یک رابطه را به یک زنجیره فروش تبدیل می‌کند.',
      points: [
        { title: 'دسترسی بدون سربار', desc: 'هر زیرآژانس یک نقطه فروش جدید است که پلتفرم هرگز مجبور نبود جداگانه آن را پذیرش یا تأمین مالی کند.' },
        { title: 'حاشیه لایه‌ای است', desc: 'آژانس اصلی می‌تواند markup لایه Retail خودش را روی قیمت پلتفرم اضافه کند پیش از آنکه زیرآژانس یک کرایه را ببیند — آن اختلاف کسب‌وکار آن است.' },
        { title: 'پاسخگویی تجمیع‌شده', desc: 'کیف پول، اعتبار و تسویه به والد بالا می‌روند، بنابراین پلتفرم با یک طرف‌مقابل تسویه می‌کند.' },
      ],
    },
    software: {
      lead: 'همه کسانی را که به یک آژانس گزارش می‌دهند فهرست می‌کند، همراه با کنترل‌هایی که آنچه هرکدام می‌تواند انجام دهد را حاکم می‌کنند.',
      points: [
        { title: 'پیکربندی به‌ازای هر آژانس', desc: 'بازنویسی‌های markup، محصولات مجاز و دسترسی روی هر زیرآژانس از رکورد آن تنظیم می‌شوند.' },
        { title: 'مجموع‌های تجمیعی', desc: 'رزروها و درآمد از زیرمجموعه به والد و مجموع شبکه تجمیع می‌شوند.' },
        { title: 'نمای مدیر در برابر آژانس', desc: 'مدیران کل شبکه را می‌بینند؛ یک آژانس واردشده فقط زیرمجموعه خودش را می‌بیند.' },
      ],
    },
    related: ['agencies', 'markup', 'partner-access'],
  },

  companies: {
    title: 'شرکت‌ها',
    tag: 'والد سازمانی',
    tagline: 'موجودیت‌های حقوقی که مالک کانال‌های فروش هستند و آژانس‌ها را زیر یک سقف گروه‌بندی می‌کنند.',
    business: {
      lead: 'یک شرکت والد سازمانی بالای آژانس‌هاست — موجودیتی که می‌تواند مالک کانال‌های فروش باشد و بنابراین کارمزدهای لایه Distribution را کسب کند. گروه‌بندی برندها یا آژانس‌ها زیر یک شرکت، مالکیت دارایی‌های تجاری مشترک و تسویه را در یک جا نگه می‌دارد.',
      points: [
        { title: 'مالک دارایی‌های توزیع', desc: 'شرکت‌ها کانال‌های فروش را در اختیار دارند (نه SIGNها)؛ قواعد Distribution یک شرکت آنچه از طریق آن کانال‌ها جریان می‌یابد را قیمت‌گذاری می‌کنند.' },
        { title: 'یک طرف‌مقابل حقوقی', desc: 'چند آژانس یا برند می‌توانند برای قراردادبندی و تسویه زیر یک شرکت واحد قرار گیرند.' },
        { title: 'تفکیک دغدغه‌ها', desc: 'صدور ایرلاین (SIGNها) با آژانس‌ها زندگی می‌کند؛ توزیع کانال با شرکت زندگی می‌کند.' },
      ],
    },
    software: {
      lead: 'دفترچه شرکت‌ها و کانال‌هایی که در اختیار دارند.',
      points: [
        { title: 'مدیریت رکوردهای شرکت', desc: 'شرکت‌ها را بسازید و ویرایش کنید و آژانس‌ها و کانال‌های متصل به هرکدام را ببینید.' },
        { title: 'مالکیت کانال', desc: 'کانال‌های فروش یک شرکت از Sale channels مدیریت می‌شوند و از Markup & Rules (لایه Distribution) قیمت‌گذاری می‌شوند.' },
        { title: 'محدوده در انتخاب‌گرها', desc: 'مالکان شرکت در انتخاب‌گر مالک Markup & Rules به‌عنوان «فقط کانال‌ها» ظاهر می‌شوند.' },
      ],
    },
    related: ['sale-channels', 'channel-access', 'agencies'],
  },

  'sale-channels': {
    title: 'کانال‌های فروش',
    tag: 'توزیع',
    tagline: 'ویترین‌ها و مجراهایی که موجودی از طریق آن‌ها فروخته می‌شود.',
    business: {
      lead: 'یک کانال فروش یک مسیر به بازار است — یک وب‌سایت، اپلیکیشن، یکپارچه‌سازی API یا میز آفلاین — که در مالکیت یک آژانس یا یک شرکت است. این دارایی‌ای است که لایه Distribution بر مبنای آن دریافت می‌کند: هر کس مالک کانال باشد می‌تواند روی آنچه از طریق آن فروخته می‌شود یک کارمزد یا سهم درآمد بگیرد.',
      points: [
        { title: 'یک کانال یک نقطه درآمد است', desc: 'فروش‌هایی که از طریق یک کانال جریان می‌یابند می‌توانند یک کارمزد Distribution یا سهم درآمد برای مالک کانال حمل کنند.' },
        { title: 'مالکیت یا قرض', desc: 'شما از طریق کانال‌های خودتان می‌فروشید، یا از طریق کانال یک شریک از طریق یک اعطای دسترسی کانال.' },
        { title: 'شکل‌دهی تقسیم', desc: 'کارمزد یک کانال می‌تواند یک افزودنی (روی کرایه) یا یک سهم-درآمد (از حاشیه فروشنده) باشد.' },
      ],
    },
    software: {
      lead: 'دفترچه کانال‌های فروش با مالک و شکل تسویه آن‌ها.',
      points: [
        { title: 'ساخت و پیکربندی', desc: 'یک کانال را ثبت کنید، مالک آن (آژانس یا شرکت) و سهم درآمد / شکل پیش‌فرض آن را تنظیم کنید.' },
        { title: 'اعطا به شرکا', desc: 'یک کانال را از طریق دسترسی کانال به بیرون به اشتراک بگذارید تا یک آژانس شریک بتواند از طریق آن بفروشد.' },
        { title: 'قیمت‌گذاری را تغذیه می‌کند', desc: 'قواعد Distribution در Markup & Rules یک کانال مشخص یا همه آن‌ها را هدف می‌گیرند.' },
      ],
    },
    related: ['channel-access', 'companies', 'partner-access', 'markup'],
  },

  'channel-access': {
    title: 'دسترسی کانال',
    tag: 'اعطای توزیع',
    tagline: 'اجازه‌دادن به یک آژانس شریک برای فروش از طریق کانال فروش شما.',
    business: {
      lead: 'دسترسی کانال نحوه قرض‌دادن یک کانال فروش به آژانسی دیگر است. مالک به یک شریک حق فروش از طریق کانالش را اعطا می‌کند — معمولاً در ازای یک سهم درآمد — و توزیع را گسترش می‌دهد بدون واگذاری دارایی. این اعطای جزئی پشت لایه قیمت‌گذاری Distribution است.',
      points: [
        { title: 'دسترسی، بر یک سهم درآمد', desc: 'گیرنده اعطا از طریق کانال می‌فروشد؛ مالک سهمی از ناخالصی که از طریق آن جریان می‌یابد را نگه می‌دارد.' },
        { title: 'رضایت دوطرفه', desc: 'یک اعطا پیشنهاد و پذیرفته می‌شود — تا هر دو طرف موافقت نکنند چیزی به اشتراک گذاشته نمی‌شود — و می‌تواند هر زمان باطل شود.' },
        { title: 'قواعد Distribution را هدایت می‌کند', desc: 'سهم درآمد اعطا پیش‌فرض قدیمی است؛ قواعد صریح Distribution در Markup & Rules آن را بازنویسی می‌کنند.' },
      ],
    },
    software: {
      lead: 'دفتر کل اعطاهای کانال — داده‌شده و دریافت‌شده.',
      points: [
        { title: 'اعطا و محدوده', desc: 'یک کانال را با یک سهم درآمد، شکل و پنجره اعتبار اختیاری به یک شریک پیشنهاد دهید.' },
        { title: 'پذیرش / رد', desc: 'گیرنده اعطا برای فعال‌کردن دسترسی می‌پذیرد، یا آن را رد می‌کند.' },
        { title: 'ابطال', desc: 'وقتی یک رابطه پایان می‌یابد دسترسی را خاتمه دهید؛ رزروهای در حال انجام بر اساس شرایط در حال اجرا تسویه می‌شوند.' },
      ],
    },
    related: ['sale-channels', 'partner-access', 'markup', 'companies'],
  },

  'sign-access': {
    title: 'دسترسی SIGN',
    tag: 'اعطای wholesale',
    tagline: 'اجازه‌دادن به یک آژانس شریک برای صدور بلیت زیر SIGN شما.',
    business: {
      lead: 'دسترسی SIGN یک اعتبارنامه صدور (یک SIGN) را به آژانسی دیگر قرض می‌دهد تا بتواند تأمین‌کننده‌ای را که برای آن اعتبارنامه در اختیار ندارد بلیت کند. مالک SIGN دسترسی را اعطا می‌کند، یک markup به‌سوی آن گیرنده اعطا تنظیم می‌کند، و می‌تواند آن را باطل کند — این اعطای پشت لایه قیمت‌گذاری Wholesale است.',
      points: [
        { title: 'صدور روی اعتبارنامه‌های قرض‌گرفته', desc: 'گیرنده اعطا زیر SIGN مالک بلیت صادر می‌کند بدون ثبت اعتبارنامه BSP/IATA خودش.' },
        { title: 'markup به‌سوی گیرنده اعطا', desc: 'مالک یک markup wholesale به‌ازای هر اعطا تنظیم می‌کند — حاشیه آن برای قرض‌دادن SIGN.' },
        { title: 'رضایت دوطرفه', desc: 'یک اعطا پیشنهاد و پذیرفته می‌شود، و می‌تواند باطل شود؛ اشتراک‌گذاری یک مجوز است، نه انتقال.' },
      ],
    },
    software: {
      lead: 'دفتر کل اعطاهای SIGN — داده‌شده و دریافت‌شده.',
      points: [
        { title: 'اعطا و تنظیم markup', desc: 'یک SIGN را با یک بازنویسی markup اختیاری و پنجره اعتبار به یک شریک پیشنهاد دهید.' },
        { title: 'پذیرش / رد', desc: 'گیرنده اعطا برای شروع صدور روی SIGN می‌پذیرد، یا رد می‌کند.' },
        { title: 'قواعد Wholesale را تغذیه می‌کند', desc: 'markup اعطا پیش‌فرض قدیمی است؛ قواعد صریح Wholesale در Markup & Rules (محدوده AGENCY / SIGN) آن را بازنویسی می‌کنند.' },
      ],
    },
    related: ['signs', 'partner-access', 'markup', 'agencies'],
  },

  signs: {
    title: 'SIGNها',
    tag: 'اعتبارنامه‌های صدور',
    tagline: 'اعتبارنامه‌های BSP / IATA / CASS که یک آژانس برای صدور بلیت استفاده می‌کند.',
    business: {
      lead: 'یک SIGN اعتبارنامه ثبت‌شده‌ای است که به یک آژانس اجازه می‌دهد بلیت‌ها را در برابر یک تأمین‌کننده مشخص صادر کند. این دارایی در قلب لایه Wholesale است: مالک SIGN می‌تواند مستقیماً صادر کند، یا SIGN را به شرکا قرض دهد (دسترسی SIGN) و روی آنچه آن‌ها صادر می‌کنند markup ببندد.',
      points: [
        { title: 'حق بلیت‌کردن', desc: 'بدون یک SIGN — یا دسترسی قرض‌گرفته‌شده به یکی — یک آژانس می‌تواند بفروشد اما نمی‌تواند در برابر آن تأمین‌کننده صادر کند.' },
        { title: 'یک فعال به‌ازای هر تأمین‌کننده', desc: 'یک آژانس یک SIGN فعال به‌ازای هر تأمین‌کننده در اختیار دارد؛ آن‌هایی که جایگزین شده‌اند بازنشسته می‌شوند، نه حذف.' },
        { title: 'دارایی wholesale', desc: 'قرض‌دادن یک SIGN و markup‌بستن روی صدور گیرنده اعطا کسب‌وکار لایه Wholesale است.' },
      ],
    },
    software: {
      lead: 'دفتر ثبت SIGNهای یک آژانس، همراه با تأمین‌کننده، کد، صادرکننده و اعتبار آن‌ها.',
      points: [
        { title: 'ثبت یک SIGN', desc: 'تأمین‌کننده، کد SIGN، صادرکننده و حساب BSP را با یک پنجره اعتبار ثبت کنید.' },
        { title: 'در مالکیت یک آژانس', desc: 'SIGNها همیشه در مالکیت یک آژانس هستند (شرکت‌ها مالک کانال‌ها هستند، نه SIGNها).' },
        { title: 'اشتراک از طریق دسترسی SIGN', desc: 'یک SIGN را از دسترسی SIGN به یک شریک قرض دهید؛ وقتی رابطه پایان می‌یابد باطل کنید.' },
      ],
    },
    related: ['sign-access', 'partner-access', 'markup', 'agencies'],
  },

  branches: {
    title: 'شعبه‌ها',
    tag: 'ساختار سازمانی',
    tagline: 'دفاتر فرعی یک آژانس، که برای محدوده‌بندی کارکنان و رزروها استفاده می‌شوند.',
    business: {
      lead: 'شعبه‌ها دفاتر فرعی فیزیکی یا سازمانی یک آژانس را مدل‌سازی می‌کنند. آن‌ها به یک آژانس بزرگ‌تر اجازه می‌دهند افرادش را سازمان‌دهی کند و رزروها و عملکرد را به دفتری که آن‌ها را انجام داده نسبت دهد، بدون تقسیم‌شدن به آژانس‌های جداگانه.',
      points: [
        { title: 'انتساب', desc: 'رزروها و درآمد می‌توانند به‌ازای هر شعبه گزارش شوند، تا ببینید کدام دفتر عملکرد دارد.' },
        { title: 'محدوده‌بندی کارکنان', desc: 'کاربران به یک شعبه تخصیص می‌یابند، و نما و مجوزهایشان را به دفترشان محدود نگه می‌دارند.' },
        { title: 'یک آژانس، چند دفتر', desc: 'شعبه‌ها یک آژانس چنددفتری را به‌عنوان یک رابطه داد و ستد واحد نگه می‌دارند.' },
      ],
    },
    software: {
      lead: 'دفترچه شعبه‌های یک آژانس.',
      points: [
        { title: 'ساخت و ویرایش', desc: 'شعبه‌ها را با نام، تماس و جزئیات موقعیت مکانی آن‌ها اضافه کنید.' },
        { title: 'تخصیص کارکنان', desc: 'شعبه هنگام تأمین کاربران و نقش‌ها زیر آژانس استفاده می‌شود.' },
        { title: 'نمای مدیر در برابر آژانس', desc: 'یک مدیر شعبه‌های هر آژانسی را مدیریت می‌کند؛ یک آژانس شعبه‌های خودش را مدیریت می‌کند.' },
      ],
    },
    related: ['agencies', 'agency-profile'],
  },

  'agency-groups': {
    title: 'گروه‌های آژانس',
    tag: 'بخش‌بندی',
    tagline: 'سطل‌های نام‌گذاری‌شده از آژانس‌ها که می‌توانید با یک قاعده قیمت‌گذاری آن‌ها را هدف بگیرید.',
    business: {
      lead: 'گروه‌های آژانس سطل‌های بخش‌بندی هستند — «متخصصان عمره»، «سازمانی‌های تهران» — که به شما اجازه می‌دهند یک مجموعه کامل از آژانس‌ها را به‌جای یکی‌یکی با هم قیمت‌گذاری کنید. آن‌ها محدوده شریک GROUP را در موتور قیمت‌گذاری تقویت می‌کنند.',
      points: [
        { title: 'قیمت‌گذاری بر اساس بخش', desc: 'یک گروه هدفی برای یک قاعده Markup & Rules با محدوده شریک = Group است.' },
        { title: 'عضویت چند-به-چند است', desc: 'یک آژانس می‌تواند به چند گروه تعلق داشته باشد؛ یک گروه آژانس‌های بسیاری را در بر می‌گیرد.' },
        { title: 'محدوده‌شده به مالک', desc: 'یک گروه پلتفرم-مشترک است یا در مالکیت یک آژانس، و یک چرخه‌عمر وضعیت را دنبال می‌کند (هرگز به‌سختی حذف نمی‌شود).' },
      ],
    },
    software: {
      lead: 'سطح مدیریت برای گروه‌ها و عضویت‌هایشان.',
      points: [
        { title: 'ساخت و مدیریت', desc: 'یک گروه را تعریف کنید و آژانس‌های عضو را اضافه یا حذف کنید.' },
        { title: 'هدف‌گیری در قیمت‌گذاری', desc: 'گروه در انتخاب‌گر محدوده-شریک Group در ویرایشگر قاعده ظاهر می‌شود.' },
        { title: 'چرخه‌عمر، نه حذف', desc: 'یک گروه را با وضعیت بازنشسته کنید تا قواعد موجودی که به آن ارجاع می‌دهند قابل‌حل بمانند.' },
      ],
    },
    related: ['markup', 'agencies'],
  },
};
